import { ajax } from '@/api/ajax'

//1、教学讨论分页
export const reqTalkList = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/getKTTalkList`, paramets)

//2、教学讨论回复分页
export const reqTalkReplyList = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/resultsToTalk`, paramets)

//3、教学讨论添加点赞
export const reqAddTalkPraise = (paramets) => ajax(`/jxtalk/jxTalkPraise/add`, paramets, 'post')

//4、教学讨论删除
export const reqDelTalk = (paramets) => ajax(`/jxclassroom/jxClassroomTalk/delete`, paramets, 'delete')

//5、教学讨论回复删除
export const reqDelReplyTalk = (paramets) => ajax(`/jxtalk/jxTalkReply/delete`, paramets, 'delete')

//6、教学讨论回复讨论
export const reqAddReplyTalk = (paramets) => ajax(`/jxtalk/jxTalkReply/add`, paramets, 'post')
